import {Injectable} from '@angular/core';
import {BekocheckAnfrage} from '../anfrage/bekocheck.anfrage';
import {BekocheckBackendService} from './backend.service';
import {PortalService} from '../../services/portal.service';
import {Router} from "@angular/router";
import {RequestService} from "../../services/request.service";
import {EmbedService} from "../../services/embed.service";
import {RequestAnfrage} from "../../model/request.anfrage";


/**
 * global advisordata that can be injected by the backend
 * @var object
 */
declare let advisorObjectData;

/**
 * Service for saving the request data locally in the browser to have it on all steps.
 */
@Injectable({
  providedIn: 'root'
})
export class BekocheckRequestService extends RequestService {

  /**
   * @inheritdoc
   */
  requestObjectName = 'bkc-anfrage';

  /**
   * constructor
   * @param backendService
   * @param portalService
   * @param router
   * @param embedService
   */
  constructor(public backendService: BekocheckBackendService, protected portalService: PortalService,
              private router: Router, protected embedService: EmbedService) {
    super(backendService, portalService, embedService);

    try {
      if (typeof advisorObjectData === "object" && typeof localStorage === "object") {
        // save injected data
        localStorage.setItem(this.requestObjectName, JSON.stringify(advisorObjectData));

        // if we preset the data, redirect to result step
        this.router.navigate([this.portalService.currentPortalId + '/bekocheck/ergebnis/betriebskostenanalyse']);
      }
    } catch (e) {

    }

    this.loadDataFromLocalStorage();
  }

  /**
   * @inheritdoc
   */
  getNewAnfrage(): RequestAnfrage {
    return new BekocheckAnfrage();
  }

  /**
   * @inheritdoc
   */
  getAnfrage(): BekocheckAnfrage {
    return super.getAnfrage() as BekocheckAnfrage;
  }

  /**
   * Sends data to API
   */
  sendDataToApi(): void {
    this.backendService.sendDataToApi(this.getAnfrage());
  }
}
